import React, { useState, useEffect } from 'react';
import Icon from '../../../Icon';

import styles from './ActiveFilters.module.css';

const FilterDropdonSelector = props => {
  const { filter, setCampaignFilters } = props;

  const [filtersList, setFiltersList] = useState([]);

  const filterGroupLabel = {
    clients: 'Client',
    responses: 'Responses',
    target: 'Target',
    language: 'Language',
    status: 'Status',
    webMobile: 'Web/Mobile',
    created: 'Created Date is',
    lastResponse: 'Last Response is',
    after: 'after',
    before: 'before',
    campaignNameSearch: 'Survey name containing'
  };

  const isValue = value => (value || value === 0) && value !== '';

  useEffect(
    () => {
      let formattedFiltesList = [];
      Object.keys(filter).map(topFilter => {
        if (filter[topFilter].value && filter[topFilter].label) {
          if (isValue(filter[topFilter].value)) {
            formattedFiltesList.push({
              label: `${filterGroupLabel[topFilter]}: ${
                filter[topFilter].label
              }`,
              path: topFilter,
              value: filter[topFilter].value
            });
          }
        } else if (Array.isArray(filter[topFilter])) {
          const arrayFilter = filter[topFilter].map(
            (arrayFilterItem, index) => {
              if (isValue(arrayFilterItem.value)) {
                return {
                  label: `${filterGroupLabel[topFilter]}: ${
                    arrayFilterItem.label
                  }`,
                  path: topFilter,
                  index,
                  value: arrayFilterItem.value
                };
              }
              return null;
            }
          );
          formattedFiltesList = [...formattedFiltesList, ...arrayFilter];
        } else {
          const arrayFilter = [];
          Object.keys(filter[topFilter]).forEach(subFilter => {
            if (isValue(filter[topFilter][subFilter].value)) {
              arrayFilter.push({
                label: `${filterGroupLabel[subFilter]}: ${
                  filter[topFilter][subFilter].label
                }`,
                path: `${topFilter}.${subFilter}`,
                value: filter[topFilter][subFilter].value
              });
            } else {
              Object.keys(filter[topFilter][subFilter]).forEach(thirdFilter => {
                if (isValue(filter[topFilter][subFilter][thirdFilter].value)) {
                  const dateElements = filter[topFilter][subFilter][
                    thirdFilter
                  ].value.split('T');
                  arrayFilter.push({
                    label: `${filterGroupLabel[subFilter]} ${
                      filterGroupLabel[thirdFilter]
                    }: ${dateElements[0]}`,
                    path: `${topFilter}.${subFilter}.${thirdFilter}`,
                    value: filter[topFilter][subFilter][thirdFilter].value
                  });
                }
              });
            }
          });
          formattedFiltesList = [...formattedFiltesList, ...arrayFilter];
        }
        return null;
      });

      setFiltersList(formattedFiltesList);
    },
    [filter]
  );

  const deepObjectValue = (obj, fullPathString) => {
    let object = obj;

    for (
      let i = 0,
        pathString = fullPathString.split('.'),
        len = pathString.length;
      i < len;
      i += 1
    ) {
      object = obj[pathString[i]];
    }
    return object;
  };

  const setDeepObjectValue = (obj, fullPathString, value) => {
    let object = obj;
    let lastObjectPath = null;

    for (
      let i = 0,
        pathString = fullPathString.split('.'),
        len = pathString.length;
      i < len;
      i += 1
    ) {
      lastObjectPath = pathString[i];

      if (i < len - 1) {
        object = object[pathString[i]];
      }
    }

    object[lastObjectPath] = value;

    return obj;
  };

  const removeFilter = (path, value) => {
    let modifiedFilter = filter;

    if (Array.isArray(deepObjectValue(modifiedFilter, path))) {
      const newArray = deepObjectValue(modifiedFilter, path).filter(
        deepValue => deepValue.value !== value
      );
      modifiedFilter = setDeepObjectValue(modifiedFilter, path, newArray);
    } else {
      modifiedFilter = setDeepObjectValue(modifiedFilter, path, {
        value: '',
        label: ''
      });
    }

    setCampaignFilters(modifiedFilter);

    return null;
  };

  return (
    <div className={styles.activeFiltersContainer}>
      {filtersList.map((activeFilter, index) => (
        <div
          className={`${
            styles.activeFilterItem
          } campaign-filters-active-filter-item`}
          key={`active-filter-container-${index.toString()}`}
        >
          <span>{activeFilter.label}</span>
          <span
            className={styles.removeIcon}
            role="presentation"
            onClick={() => removeFilter(activeFilter.path, activeFilter.value)}
          >
            <Icon type="close" />
          </span>
        </div>
      ))}
      {filtersList && filtersList.length ? (
        <span
          className={`${
            styles.clearAllFilters
          } campaign-filters-clear-all-filters-button`}
          role="presentation"
          onClick={() => setCampaignFilters({})}
        >
          Clear all filters
        </span>
      ) : null}
    </div>
  );
};

export default FilterDropdonSelector;
